import { render, staticRenderFns } from "./canvaTab.vue?vue&type=template&id=db52745e&scoped=true&"
import script from "./canvaTab.vue?vue&type=script&lang=js&"
export * from "./canvaTab.vue?vue&type=script&lang=js&"
import style0 from "./canvaTab.vue?vue&type=style&index=0&id=db52745e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52745e",
  null
  
)

export default component.exports